module.exports = __webpack_public_path__ + "img/Device-Admin-Lit.f5949085.png";